import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'

import { Button, Chip } from '@material-ui/core'

function PaymentsListItem({ item, classes, showRefundModal }) {
  return (
    <tr key={item.orderNumber} className={item.situation === 1 && 'scheduled'}>
      <td>
        <div className="post-title">{item.orderNumber}</div>
      </td>
      <td>
        <div className="wrapper-post-title">
          <div className="post-title">{item.clientName}</div>
          {/* TODO: Verificar a necessidade deste modal */}
          {/* <div> */}
          {/*  <a onClick={() => setShowPerfilModal({ ...item, show: true })}> */}
          {/*    Visualizar perfil */}
          {/*  </a> */}
          {/* </div> */}
        </div>
      </td>
      <td>R$ {`${item.discountedValue.toFixed(2)}`.replace('.', ',')}</td>
      <td>
        <span className="datetime">
          {item.paymentDateTime
            ? moment(item.paymentDateTime).format('L [às] LT')
            : moment(item.createdAt).format('L [às] LT')}
        </span>
      </td>
      {/* TODO: 1->Pendente, 2->Pago, 3-> Cancelado, 4-> estornado */}
      <td>
        {item.situation === 1 && <Chip label="Pendente" className={classes.statusPendent} />}
        {item.situation === 2 && (
          <>
            <Chip label="Pago" className={classes.statusPaid} />{' '}
            {moment().utcOffset(0).subtract(1, 'day').isBefore(item.updatedAt) && (
              <Button variant="outlined" onClick={() => showRefundModal(item)}>
                Estornar
              </Button>
            )}
          </>
        )}
        {item.situation === 3 && <Chip label="Cancelado" className={classes.statusCancelled} />}
        {item.situation === 4 && <Chip label="Estornado" className={classes.statusCancelled} />}
      </td>
    </tr>
  )
}

PaymentsListItem.protoTypes = {
  item: PropTypes.objectOf(PropTypes.object).isRequired,
  classes: PropTypes.objectOf(PropTypes.object).isRequired
}

export default PaymentsListItem
